/**
* @name:左侧中间部分
* @author kk
* @date 2019/11/7
*/
<template>
  <div class="left-content">
    <layer title="" width="440px" :padding="state===1?'8px 20px 5px':'35px 20px 30px'" :showMoreTag="false">
      <!--承包商下拉框-->
      <el-row type="flex" align="middle">
        <el-col :span="12">
          <p class="cbs">共有运营商
            <span class="cbs-num">{{ total }}</span>家
          </p>
        </el-col>
        <el-col :span="12" v-if="supplierList.length > 0">
          <el-select v-model="supplier" placeholder="请选择" @change="changeSupplier">
            <el-option
                v-for="item in supplierList"
                :key="item.contractorId"
                :label="item.contractorName"
                :value="item.contractorId">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 三大安全员 -->
      <el-row v-show="res" :style="{padding: state===1?'':'30px 0 20px'}">
        <el-col :span="8" style="text-align: center">
          <div class="management-avator person-cus" @click="showPeson(res.deptLeadId, 0)">
            <img :src="res.deptLeadAvatar?(imgUrl+res.deptLeadAvatar):avatar" alt="">
          </div>
          <el-row>
            <span class="userName person-cus">负责人</span>
          </el-row>
          <el-row>
            <span class="position person-cus">{{res.deptLead}}</span>
          </el-row>
        </el-col>
        <el-col :span="8" style="text-align: center;">
          <div class="management-avator person-cus" @click="showPeson(res.safeTechId, 1)">
            <img :src="res.safeTechAvatar?(imgUrl+res.safeTechAvatar):avatar" alt="">
          </div>
          <el-row>
            <span class="userName person-cus">安全专业技术人员</span>
          </el-row>
          <el-row>
            <span class="position person-cus">{{res.safeTech}}</span>
          </el-row>
        </el-col>
        <el-col :span="8" style="text-align: center">
          <div class="management-avator person-cus" @click="showPeson(res.safeManagerId, 2)">
            <img :src="res.safeManagerAvatar?(imgUrl+res.safeManagerAvatar):avatar" alt="">
          </div>
          <el-row>
            <span class="userName person-cus">安全管理员</span>
          </el-row>
          <el-row>
            <span class="position person-cus">{{res.safeManager}}</span>
          </el-row>
        </el-col>
      </el-row>
      <div class="no-the-data" :style="{minHeight: state===1?'121px':'170px'}" v-show="!res">
        <div>
          <i class="iconfont icon-suoyourenyuan dzi"></i>
          <p>暂无负责人</p>
        </div>
      </div>
      <transition name="slide-left-fade">
        <popup :title="detailTitle" class="people-pop" v-if="morePeople" width="420px" @closeEvent="morePeople = false">
          <div class="person-content">
            <div class="person-img">
              <img :src="(detailInfo.fileId&&detailInfo.fileId[0])?(imgUrl+detailInfo.fileId[0]):avatar"
                  width="116"
                  alt="">
            </div>
            <div class="person-info-name">
              <p>姓名</p>
              <p>手机</p>
              <p>邮箱</p>
              <p>所属食堂</p>
              <p>所属运营商</p>
            </div>
            <div class="person-info-data">
              <p>{{ detailInfo.userName }}</p>
              <p>{{detailInfo.phone ||'无'}}</p>
              <p>{{detailInfo.email ||'无'}}</p>
              <p>
                <span v-if="detailInfo.departmentName===null">无</span>
                <span v-for="(item,index) in detailInfo.departmentName" :key="index">{{item}}{{detailInfo.departmentName.length > 1 ? '、': ''}}</span>
              </p>
              <p>{{ detailInfo.businessName }}</p>
            </div>
          </div>
        </popup>
      </transition>
      <!--许可证-->
      <zzYC :contractorId="supplier" :contractorName="contractorName" :status="status" :state="state" :style="{padding: state===1?'':'0px 0 10px'}"></zzYC>
      <xcPerson :contractorId="supplier" :style="{padding: state===1?'':'0 0 10px'}"></xcPerson>
      <gdzcGZZD :contractorId="supplier" :style="{padding: supplierList.length>0?'':'0px 0'}"></gdzcGZZD>
    </layer>
  </div>
</template>

<script>
  export default {
    name: 'leftInfo',
    data () {
      return {
        deptId: this.$route.query.deptId,
        imgUrl: this.$store.getters.fileApi,
        avatar: require('../../assets/images/avatar.jpg'),
        list: [],
        morePeople: false,
        res: '',
        detailInfo: {},
        supplierList: [],
        supplier: '',
        contractorName: '',
        status: '',
        tmpId: 0,
        detailTitle: '食堂负责人'
      }
    },
    props: {
      state: {
        default: 0,
        type: Number
      },
      total: {
        default: 0,
        type: Number
      }
    },
    async mounted () {
      await this.contraListGet(this.deptId)
      this.getDeptsafeconfigImg(this.supplier)
      this.$nextTick(() => {
        document.addEventListener('click', (e) => {
          if (e.target.className === 'point') {
            this.morePeople = false
          }
        })
      })
    },
    methods: {
      /**
       * @Description: 获取管理员
       * @author kk
       * @param supplier 承包商id
       * @date 2019/11/7
       */
      getDeptsafeconfigImg (supplier) {
        console.log('xian22222', supplier)
        let params = {
          departmentId: this.deptId,
          contractorId: supplier
        }
        this.$request.deptsafeconfigImgGet(params).then(res => {
          console.log('查看三大管理员--------', res)
          this.res = res
        }).catch(e => {
          console.error(e.msg)
          this.res = ''
        })
      },
      /**
       * @Description: 判断人员状态
       * @author kk
       * @param num 人员状态
       * @date 2019/11/5
       */
      statusFilter (num) {
        switch (num) {
          case '0':
            return '已到期'
          case '1':
            return '即将到期'
          case '2':
            return '正常'
          default:
            return ''
        }
      },
      /**
       * @Description:显示安全人员详情
       * @author wanghongling
       * @param id
       * @param type 安全人员类型
       * @createDate 2019/12/4
      */
      showPeson (id, type) {
        switch (type) {
          case 0:
            this.detailTitle = '食堂负责人'
            break
          case 1:
            this.detailTitle = '安全专业技术人员'
            break
          case 2:
            this.detailTitle = '安全管理员'
            break
          default:
            break
        }
        this.$request.deptsafeconfigPcGet({departmentId: this.deptId, userId: id}).then(res => {
          console.log(res, '!!!!!!!!!!!!!!!!!!!!!!!!!!!!!', type, this.tmpId)
          if (this.tmpId === type) {
            this.morePeople = !this.morePeople
          } else {
            this.morePeople = true
          }
          this.detailInfo = res
          console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^', res)
          this.tmpId = type
        }).catch(e => {
          console.error(e)
          this.morePeople = false
        })
      },
      /**
       * @Description:切换承包商
       * @author wanghongling
       * @param val 承包商id
       * @createDate 2019/12/4
      */
      changeSupplier(val) {
        this.supplier = val
        this.getDeptsafeconfigImg(val)
        this.morePeople = false
        this.supplierList.map(v => {
          if (v.contractorId === val) {
            this.contractorName = v.contractorName
            this.status = v.status
          }
        })
        console.log('切换承包商', this.supplier, this.contractorName)
      },
      /**
       * @Description:
       * @author wanghongling
       * @param deptId 食堂id
       * @createDate 2019/12/6
       */
      contraListGet(deptId) {
        return this.$request.constramanageContraListGet({departmentId: deptId}).then(res => {
          console.log('根据食堂ID，获取供应商列表', res)
          if (!this.$utils.isEmptyObject(res)) {
            this.supplierList = res.list
            this.supplier = res.list.length > 0 ? res.list[0].contractorId : ''
            this.contractorName = res.list.length > 0 ? res.list[0].contractorName : ''
            this.status = res.list.length > 0 ? res.list[0].status : '0'
          } else {
            this.supplierList = []
            this.supplier = ''
          }
        }).catch(e => {
          console.error(e)
        })
      }
    }
  }
</script>

<style lang="less" rel="stylesheet/less">
  @import '../../assets/less/color';

  .left-content {
    font-size: 14px;
    color: @lightBlue;

    .cbs {
      color: @darkBlue;
      font-size: 16px;
    }

    .cbs-num {
      font-size: 20px;
      color: @lightBlue;
      padding: 0 5px;
    }

    .person-cus{
      cursor: pointer
    }

    .management-avator {
      margin: 10px auto 5px;
      width: 68px;
      height: 68px;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .userName {
      color: #00fffc;
    }

    .position {
      font-size: 12px;
      color: #83adbb;
    }

    .item-avator {
      margin: 10px auto;
      width: 68px;
      height: 68px;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      border-radius: 50%;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
      &-temp{
        position: absolute;
        top: 0;
        left: 40px;
        background: #18ac00;
        color: #fff;
        border-radius: 9px;
        padding: 1px;
        min-width: 80px;
        font-size: 12px;
      }
      .tem-yc{
        background-color: #ff6600;
      }
    }

    .people-pop {
      position: absolute;
      left: 450px;
      top: 145px;
      z-index: 1;
    }

    .person-content {
      display: flex;

      p {
        line-height: 25px;
      }

      .person-img {
        width: 35%;
        margin-top: 5px;
      }

      .person-info-name {
        width: 25%;
        color: #00aaf1;
        text-align: left;
      }

      .person-info-data {
        width: 40%;
      }
    }

    .name {
      font-size: 14px;
      color: @lightBlue;
    }

    .status {
      padding: 2px 5px;
      margin-left: 7px;
      color: #fff;
      font-size: 12px;
      border-radius: 5px;

      &_1 {
        background: @orange;
      }

      &_0 {
        background: @darkRed;
      }

      &_null {
        display: none;
      }
    }

    .time {
      margin-top: 5px;
      color: @lightGrey;
      font-size: 12px;
    }

    .el-carousel--horizontal {
      margin-bottom: -10px;
      /*padding-top: 30px;*/
      /*margin-top: -40px;*/
    }

    .el-carousel__indicators--outside {
      top: 4px;
      right: 0;
      left: inherit;
      text-align: center;
      position: absolute;
      -webkit-transform: none;
      transform: none;
    }

    .el-carousel__container {
      height: 130px;
    }

    .el-carousel__button {
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .el-carousel__indicators--outside button {
      background-color: #0a8b9c;
    }

    .el-carousel__indicator--horizontal {
      padding: 6px 4px;
    }
    .el-input__inner{
      background-color: #06263a;
      border: 1px solid #146496;
      color: #00ea7a;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shitang/leftInfo.vue